export default __webpack_public_path__ + "static/media/img-0647-north-macedonia-premium-face.e2287bee.png";